import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { ICompanyItemDetails } from './components/CompaniesList/ICompaniesList';
import { isFeedVisible } from './pages/FeedPage/functions';
import { TUserInfo } from '@features/reducer.info';
import VerificationPage from './pages/VerificationPage/VerificationPage';
import CollaboratorsPage from './pages/CollaboratorsPage/CollaboratorsPage';
import OverviewPage from './pages/OverviewPage/OverviewPage';
import FeedPage from './pages/FeedPage/FeedPage';
import { TReducers } from '@features/reducers';
import FundsApp from '@funds/index';
import NoPhotoMaleBigImage from '@images/no_photo_male_big.png';

import * as app from './AppStyle.module.scss';

interface ICompanyProps extends RouteComponentProps<any> {
  editMode: boolean;
  isCreator: boolean;
  isOwner: boolean;
  isUsInvestor: boolean;
  info: TUserInfo;
  isSaving: boolean;
  companyDetails: ICompanyItemDetails;
}

export class Company extends React.Component<ICompanyProps> {
  restrictedSubmenuSections = [
    'overview',
    'collaborators',
    'verification',
    'funds',
  ];

  componentDidMount() {
    if (this.restrictedSubmenuSections.includes(this.props.match.params.tab) && !this.props.info) {
      this.props.history.push(`/error/403`);
    }
  }

  renderApp = () => {
    const userSignedIn = !!this.props.info;

    switch (this.props.match.params.tab) {
      case 'verification':
        return (
          <VerificationPage {...this.props} />
        );
      case 'funds':
        return (
          userSignedIn &&
            <FundsApp match={this.props.match} history={this.props.history} location={this.props.location} />
        );
      case 'collaborators':
        return (
          <CollaboratorsPage companyId={this.props.companyDetails.id} />
        );
      case 'overview': case undefined:
        return (
          <OverviewPage
            {...this.props}
            companyId={this.props.companyDetails.id}
            editMode={this.props.editMode}
            isSaving={this.props.isSaving}
            userSignedIn={userSignedIn}
            companyDetails={this.props.companyDetails}
            isUsInvestor={this.props.isUsInvestor}
            isCreator={this.props.isCreator}
            isOwner={this.props.isOwner}
            setEditMode={() => {}}
          />
        );
      case 'discussion': case 'investor_zone':
        if (!isFeedVisible(this.props.companyDetails.labels)) {
          this.props.history.push(`/error/404`);
        }
        return (
          <FeedPage
            isUsInvestor={this.props.isUsInvestor}
            companyId={this.props.companyDetails.id}
            isAllowed={userSignedIn}
            userProfileId={this.props.info && this.props.info.profile_id || null}
            userSignedIn={userSignedIn}
            hasInvestorAccess={this.props.companyDetails.current_user_investor_access}
            tmp={this.props.match.params.tab}
            isCreator={this.props.isCreator}
            isOwner={this.props.isOwner}
            profileId={this.props.companyDetails.profile_id}
            profileAvatar={this.props.info && this.props.info.avatar_url || NoPhotoMaleBigImage}
            push={this.props.history.push}
          />
        );
      default:
        this.props.history.push(`/error/404`);
        break;
    }
    return;
  }

  render() {
    return (
      <div
        className={
          [app.companyContent, this.props.editMode ? '': ''].join(' ')
        }
      >
      {this.renderApp()}
      </div>
    );
  }
}

const mapStateToProps = (store: TReducers) => {
  return {
    isSaving: store.companyReducer.isSaving,
    formDirty: store.companyReducer.formDirty,
    companyDetails: store.companyReducer.companyDetails,
    info: store.userInfo,
  };
};

export default connect(mapStateToProps)(Company);
